import React, { useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { getLanguageFromUrl } from '../../utils/languageUtils';

const LanguageDetector = () => {
  const { changeLanguage } = useLanguage();

  useEffect(() => {
    const detectAndSetLanguage = () => {
      // Проверяем, есть ли язык в URL
      const urlLanguage = getLanguageFromUrl();
      if (urlLanguage) {
        changeLanguage(urlLanguage);
        return;
      }

      // Проверяем, есть ли уже сохраненный язык
      const savedLanguage = localStorage.getItem('language');
      if (savedLanguage) {
        changeLanguage(savedLanguage);
        return;
      }

      // Определяем язык на основе геолокации пользователя
      const userRegion = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Если пользователь из России, Украины, Беларуси, Казахстана или других стран СНГ - устанавливаем русский
      const cisCountriesTimezones = [
        'Europe/Moscow',
        'Europe/Kiev',
        'Europe/Minsk',
        'Asia/Almaty',
        'Asia/Tashkent',
        'Europe/Samara',
        'Asia/Yekaterinburg',
        'Asia/Omsk',
        'Asia/Krasnoyarsk',
        'Asia/Irkutsk',
        'Asia/Yakutsk',
        'Asia/Vladivostok',
        'Asia/Magadan',
        'Asia/Kamchatka'
      ];

      const detectedLanguage = cisCountriesTimezones.includes(userRegion) ? 'ru' : 'en';
      changeLanguage(detectedLanguage);
    };

    detectAndSetLanguage();
  }, [changeLanguage]);

  return null; // Этот компонент не отображает ничего визуально
};

export default LanguageDetector;